import React, {Fragment} from 'react';
import QuickReplyOperations from './QuickReplyOperations';
import {randstr, showToast} from '../../Common/Appcommon';

class QuickReplyEdit extends React.Component {

    formname = process.env.REACT_APP_QUICKREPLY_FORMNAME;

    constructor(props) {
        super(props);

        const type = `auto-reply`;
        const quickReplyId = props.match === undefined || props.match.params.id === undefined ? '' : props.match.params.id;

        this.state = {
            showActionModal : false,
            quickReplyId : quickReplyId,
            type : type,
        }
    }

    toggleActionsModal = (show,id,updateData,isupdate) => {
        if(!show){
            window.location.href = "#/chatbots";
            if(isupdate){
                showToast(`Chat Bot updated successfully`);
            }else{
                showToast(`Chat Bot created successfully`);
            }
        }
    }

    render() {

        let { showActionModal, quickReplyId, type } = this.state;

        return (
            <Fragment>
                <QuickReplyOperations
                    key={randstr('quickrep_')}
                    showActionModal={showActionModal}
                    quickReplyId={quickReplyId}
                    toggleActionsModal={this.toggleActionsModal}
                    type={type}
                    useForm={this.props.useForm}
                />
            </Fragment>
        )
    }

}

export default QuickReplyEdit;
